"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.awaitMultipleWalletScans = exports.awaitWalletScan = exports.balanceForERC20Token = exports.onBalancesUpdate = exports.setOnBalanceUpdateCallback = void 0;
const engine_1 = require("@railgun-community/engine");
const shared_models_1 = require("@railgun-community/shared-models");
const logger_1 = require("../../../utils/logger");
const bytes_1 = require("../util/bytes");
const core_1 = require("../core");
let onBalanceUpdateCallback;
const setOnBalanceUpdateCallback = (callback) => {
    onBalanceUpdateCallback = callback;
};
exports.setOnBalanceUpdateCallback = setOnBalanceUpdateCallback;
const getSerializedERC20Balances = (balances) => {
    const tokenHashes = Object.keys(balances);
    return tokenHashes
        .filter(tokenHash => {
        return balances[tokenHash].tokenData.tokenType === engine_1.TokenType.ERC20;
    })
        .map(railgunBalanceAddress => {
        const erc20Balance = {
            tokenAddress: (0, bytes_1.parseRailgunTokenAddress)(balances[railgunBalanceAddress].tokenData.tokenAddress).toLowerCase(),
            amount: balances[railgunBalanceAddress].balance,
        };
        return erc20Balance;
    });
};
const getNFTBalances = (balances) => {
    const tokenHashes = Object.keys(balances);
    return tokenHashes
        .filter(tokenHash => {
        return ([engine_1.TokenType.ERC721, engine_1.TokenType.ERC1155].includes(balances[tokenHash].tokenData.tokenType) && balances[tokenHash].balance > BigInt(0));
    })
        .map(tokenHash => {
        const tokenData = balances[tokenHash].tokenData;
        const nftBalance = {
            nftAddress: (0, bytes_1.parseRailgunTokenAddress)(tokenData.tokenAddress).toLowerCase(),
            nftTokenType: tokenData.tokenType,
            tokenSubID: tokenData.tokenSubID,
            amount: balances[tokenHash].balance,
        };
        return nftBalance;
    });
};
const onBalancesUpdate = async (wallet, chain) => {
    (0, logger_1.sendMessage)(`Wallet balance SCANNED. Getting balances for chain ${chain.type}:${chain.id}.`);
    if (!onBalanceUpdateCallback) {
        return;
    }
    const balances = await wallet.balances(chain);
    const erc20Amounts = getSerializedERC20Balances(balances);
    const nftAmounts = getNFTBalances(balances);
    const balancesEvent = {
        chain,
        erc20Amounts,
        nftAmounts,
        railgunWalletID: wallet.id,
    };
    onBalanceUpdateCallback(balancesEvent);
};
exports.onBalancesUpdate = onBalancesUpdate;
const balanceForERC20Token = async (wallet, networkName, tokenAddress) => {
    const { chain } = shared_models_1.NETWORK_CONFIG[networkName];
    const balances = await wallet.balances(chain);
    const tokenBalances = getSerializedERC20Balances(balances);
    const matchingTokenBalance = tokenBalances.find(tokenBalance => tokenBalance.tokenAddress.toLowerCase() === tokenAddress.toLowerCase());
    if (!matchingTokenBalance) {
        return 0n;
    }
    return matchingTokenBalance.amount;
};
exports.balanceForERC20Token = balanceForERC20Token;
const awaitWalletScan = (walletID, chain) => {
    const wallet = (0, core_1.walletForID)(walletID);
    return new Promise((resolve, reject) => wallet.once(engine_1.EngineEvent.WalletScanComplete, ({ chain: returnedChain }) => returnedChain.type === chain.type && returnedChain.id === chain.id
        ? resolve(returnedChain)
        : reject()));
};
exports.awaitWalletScan = awaitWalletScan;
const awaitMultipleWalletScans = async (walletID, chain, numScans) => {
    let i = 0;
    while (i < numScans) {
        // eslint-disable-next-line no-await-in-loop
        await (0, exports.awaitWalletScan)(walletID, chain);
        i += 1;
    }
    return Promise.resolve();
};
exports.awaitMultipleWalletScans = awaitMultipleWalletScans;
